export function sortSeries(series) {
    series?.sort((first, second) => {
      const firstSum = summarized(first);
      const secondSum = summarized(second);

      if (firstSum > secondSum) {
        return 1;
      }

      if (firstSum < secondSum) {
        return -1;
      }

      return 0;
    })
    .reverse()
    .slice(0, 10);
    return series;
}

function summarized(array) {
  if (array?.data?.every(value => Boolean(value.length))) {
    return summarizedMatrixData(array);
  }
  return summarizedArraysData(array);
}

function summarizedArraysData(array) {
  return array?.data?.reduce((sum, value) => sum + value, 0);
}

function summarizedMatrixData(array) {
  return array?.data?.reduce((sum, value) => sum + value[1], 0);
}
